import {
  NBS_API_ONE_CLICK_LOGIN_REQUEST,
  NBS_API_ONE_CLICK_LOGIN_SUCCESS,
  NBS_API_ONE_CLICK_LOGIN_FAILURE
} from '../../constants/actions';
import nbsApi from '../../assets/helpers/nbsApi';
import { deviceId } from '../../assets/helpers/utils';

function nbsApiOneClickLoginRequest () {
  return { type: NBS_API_ONE_CLICK_LOGIN_REQUEST };
}

function nbsApiOneClickLoginSuccess (response) {
  return {
    type: NBS_API_ONE_CLICK_LOGIN_SUCCESS,
    response
  };
}

function nbsApiOneClickLoginError (error) {
  return {
    type: NBS_API_ONE_CLICK_LOGIN_FAILURE,
    error: error.cause || error
  };
}

export function nbsApiOneClickLogin (data) {
  data.device_id = deviceId();
  const url = 'login';
  return dispatch => {
    dispatch(nbsApiOneClickLoginRequest());
    return nbsApi(url, data)
      .then(response => dispatch(nbsApiOneClickLoginSuccess(response)))
      .catch(error => dispatch(nbsApiOneClickLoginError(error)));
  };
}
